import React from 'react';
import WrappedBase from './WrappedBase';

import QuantityLimit from '../containers/QuantityLimit';

export default class QuantityLimitWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <QuantityLimit {...this.props} />
      </WrappedBase>
    );
  }
}
